import { Gift, Check, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import bonusCartasImg from "@/assets/bonus-cartas.png";
import bonusPlanificadorImg from "@/assets/bonus-planificador.png";
import bonusBlindajeImg from "@/assets/bonus-blindaje.png";
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const bonuses = [{
  image: bonusCartasImg,
  title: "La Bóveda de Cartas de Acero",
  subtitle: "❌ Deja de enviar cartas que los burós ignoran\n✅ Usa plantillas legales que los obligan a responder",
  features: ["Cartas de Disputa Estratégicas (FCRA § 611)", "Negociación con Acreedores (Pay for Delete, Goodwill)", "Recursos Gubernamentales (CFPB, Fiscal General)"],
  value: "$67"
}, {
  image: bonusPlanificadorImg,
  title: 'Planificador "Score 700 en 12 Meses"',
  subtitle: "🗓️ Sabes exactamente qué hacer cada mes para subir tu score sin sabotearlo",
  features: ["Plan Mensual de 12 Meses (4 Fases)", "Calendario de Disputas + Registro Comunicaciones", "Hoja de Cálculo Automatizada (Google Sheets)"],
  value: "$47"
}, {
  image: bonusBlindajeImg,
  title: 'Guía "Crédito Blindado"',
  subtitle: "⚠️ El error #1 de quienes suben su crédito: no protegerlo después\n✅ Protección Contra Robo de Identidad y Errores",
  features: ["El Escudo Preventivo (Congelamiento Triple)", 'Kit de Emergencia + Protocolo "Fui Víctima"', "Tarjeta de Bolsillo + Checklist 5 Minutos"],
  value: "$67"
}];
const totalBonusValue = 67 + 47 + 67; // $181
const ebookValue = 147;
const totalValue = totalBonusValue + ebookValue; // $322

const BonusSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden section-padding gradient-hero">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      <div className="container-centered relative z-10">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-4 py-2">
            <Gift className="h-5 w-5 text-slate-900" />
            <span className="font-semibold text-slate-900 text-xl">Bonos Exclusivos</span>
          </div>
          <h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
            3 BONOS EXCLUSIVOS <span className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">(Valor ${totalBonusValue})</span>{" "}
            <span className="text-primary">GRATIS</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-semibold text-secondary-foreground">
            Incluidos sin costo adicional cuando adquieres El Código del Crédito Perfecto hoy
          </p>
        </div>

        {/* Ebook Principal */}
        <div className="mb-12 flex flex-col items-center gap-8 rounded-2xl border-2 border-primary/30 bg-card p-6 md:flex-row md:p-8">
          <div className="w-full max-w-xs flex-shrink-0">
            <img alt="El Código del Crédito Perfecto - Ebook Principal" className="w-full rounded-lg shadow-xl" loading="lazy" decoding="async" width="522" height="284" src="/lovable-uploads/e6f3986d-6e70-4f04-8098-e348afcbacf4.webp" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <span className="inline-block rounded bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-3 py-1 font-bold text-slate-900 text-lg">
              PRODUCTO PRINCIPAL
            </span>
            <h3 className="mt-3 font-display text-2xl md:text-3xl text-secondary-foreground font-extrabold">
              El Código del Crédito Perfecto
            </h3>
            <p className="mt-2 text-lg text-muted-foreground font-bold">
              7 módulos, 120+ páginas de estrategias probadas para transformar tu crédito
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-3 md:justify-start text-xl">
              <span className="rounded-full bg-secondary/20 px-4 py-1 text-sm font-medium text-secondary-foreground">
                👉 Sabes exactamente qué hacer, qué evitar y en qué orden actuar  Valor: ${ebookValue}
              </span>
            </div>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div className="grid gap-6 md:grid-cols-3">
          {bonuses.map((bonus, index) => <div key={index} className="group relative overflow-hidden rounded-2xl border-2 border-dashed border-accent/30 bg-card p-6 transition-all duration-300 hover:border-accent hover:shadow-lg">
              {/* Value Badge */}
              <div className="absolute right-4 top-4 z-10">
                <span className="rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-3 py-1 text-sm font-bold text-slate-900">
                  Valor: {bonus.value}
                </span>
              </div>

              {/* Image */}
              <div className="mb-4 overflow-hidden rounded-lg">
                <img src={bonus.image} alt={bonus.title} className="h-48 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105" loading="lazy" decoding="async" width="384" height="192" />
              </div>

              {/* Content */}
              <div className="flex items-center gap-2">
                <span className="text-xs font-bold uppercase bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">Bono #{index + 1}</span>
                <span className="rounded bg-gradient-to-r from-teal-500/20 via-cyan-400/20 to-amber-500/20 px-2 py-0.5 text-xs font-semibold text-cyan-400">GRATIS</span>
              </div>
              <h3 className="mt-2 font-display text-center text-xl text-secondary-foreground font-extrabold">
                {bonus.title}
              </h3>
              <div className="mt-1 text-sm text-secondary-foreground space-y-1">
                {bonus.subtitle.split('\n').map((line, lineIndex) => {
                  const emojiMatch = line.match(/^(\p{Emoji_Presentation}|\p{Emoji}\uFE0F?)/u);
                  const emoji = emojiMatch ? emojiMatch[0] : '';
                  const text = emoji ? line.slice(emoji.length).trim() : line.trim();
                  return (
                    <p key={lineIndex} className="flex items-start gap-2">
                      <span className="flex-shrink-0">{emoji}</span>
                      <span>{text}</span>
                    </p>
                  );
                })}
              </div>

              {/* Features */}
              <ul className="mt-4 space-y-2">
                {bonus.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start gap-2 text-sm">
                    <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-primary" />
                    <span className="font-bold text-secondary-foreground">{feature}</span>
                  </li>)}
              </ul>

              {/* Price */}
              <div className="mt-4 pt-4 border-t border-border">
                <p className="text-sm font-semibold text-secondary-foreground">
                  {bonus.value} → <span className="text-primary">HOY GRATIS</span>
                </p>
              </div>
            </div>)}
        </div>

        {/* Total Value Banner */}
        <div className="mt-10 rounded-2xl bg-gradient-to-r from-teal-600 via-cyan-500 to-amber-500 p-6 text-center sm:p-8">
          <p className="font-display text-lg font-bold text-slate-900 sm:text-xl">
            TOTAL VALOR BONOS: ${totalBonusValue} + Ebook ${ebookValue} ={" "}
            <span className="text-2xl line-through opacity-70">${totalValue}</span>
          </p>
          <p className="mt-3 font-display text-2xl font-bold text-slate-900 sm:text-3xl">
            TU INVERSIÓN HOY: SOLO <span className="rounded-lg px-4 text-7xl py-0 bg-slate-900 text-white">$16.99</span>
          </p>
          <p className="mt-2 text-sm font-semibold text-slate-800">
            ⚠️ Este precio no se mantendrá cuando cierres esta página
          </p>

          {/* CTA Button */}
          <Button onClick={handleBuyClick} size="lg" className="btn-cta mt-6 h-14 bg-slate-900 px-10 text-lg font-bold text-white shadow-lg transition-all hover:scale-105 hover:bg-slate-800">
            <Zap className="mr-2 h-5 w-5 flex-shrink-0" />
            <span className="text-center whitespace-normal">¡OBTENER TODO AHORA!</span>
          </Button>
        </div>
      </div>
    </section>;
};
export default BonusSection;